import { useEffect, useState } from "react";
import '../styles/Form.css'
import { useAuth } from "./AuthContext";
import { ClipLoader } from 'react-spinners';
import { useNavigate } from "react-router-dom";
import { useDarkMode } from '../utils/DarkModeProvider';
import darkModeStyles from '../styles/TableDarkMode'
import lightModeStyles from '../styles/TableLightMode'
import { FiEye, FiEyeOff } from 'react-icons/fi'
import Swal from 'sweetalert2'

export default function Login() {

    const navigate = useNavigate();

    const { darkMode, toggleDarkMode } = useDarkMode();
    const dynamicStyles = darkMode ? darkModeStyles : lightModeStyles

    const { login, error, setError, loading } = useAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [mostrarPassword, setMostrarPassword] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        login(email, password)
    }

    const mostrarRecuperarAcceso = () => {
        Swal.fire({
            icon: 'info',
            title: 'Recuperar contraseña',
            html: 'Deberá comunicarse por mail de acuerdo a su Unidad Académica:<br/><br/><strong>SOC:</strong> <span style="color:#38bdf8; font-weight:600;">evaluaciondocente-soc@unq.edu.ar</span><br/><strong>CyT:</strong> <span style="color:#38bdf8; font-weight:600;">evaluaciondocente-cyt@unq.edu.ar</span><br/><strong>EUdA:</strong> <span style="color:#38bdf8; font-weight:600;">evaluaciondocente-eua@unq.edu.ar</span><br/><strong>EyA:</strong> <span style="color:#38bdf8; font-weight:600;">evaluaciondocente-eya@unq.edu.ar</span>',
            confirmButtonText: 'Cerrar',
            confirmButtonColor: '#972034',
            background: darkMode ? '#1e1e1e' : '#fff',
            color: darkMode ? '#fff' : '#545454'
        })
    }

    return (
        <div className={darkMode ? "div-container-dark-mode" : "div-container-light-mode"} data-bs-theme={darkMode ? "dark" : "light"}>
            <div className="toggle-container">
                <label className="toggle-switch">
                    <input type="checkbox" checked={darkMode} onChange={toggleDarkMode} />
                    <span className="slider"></span>
                    <span className="toggle-icons">
                        {darkMode ? '🌙' : '☀️'}
                    </span>
                </label>
            </div>
            <div style={dynamicStyles.container}>
                <div style={styles.imageContainer}>
                    <img src={darkMode ? require('../assets/images/logo_unq_negativo_blanco.png') : require('../assets/images/logo_unq_negativo_negro_rojo.png')} className="unqImage" />
                    <div style={dynamicStyles.card}>
                        <h2 style={dynamicStyles.loginTitle}>Ingresar</h2>

                        <form onSubmit={handleSubmit}>
                            <div style={styles.inputGroup}>
                                <label style={dynamicStyles.loginLabel}>Usuario</label>
                                <input
                                    placeholder="Usuario"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    style={{ ...dynamicStyles.input, width: '100%' }}
                                />
                            </div>

                            <div style={styles.inputGroup}>
                                <label style={dynamicStyles.loginLabel}>Contraseña</label>
                                <div style={styles.passwordWrapper}>
                                    <input
                                        type={mostrarPassword ? "text" : "password"}
                                        placeholder="Contraseña"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        style={{ ...dynamicStyles.input, width: '100%', paddingRight: 42 }}
                                    />
                                    <button
                                        type="button"
                                        onClick={() => setMostrarPassword((prev) => !prev)}
                                        style={{
                                            ...styles.passwordToggleButton,
                                            color: darkMode ? '#6c757d' : '#ccc'
                                        }}
                                        aria-label={mostrarPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                                        title={mostrarPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                                    >
                                        {mostrarPassword ? <FiEyeOff /> : <FiEye />}
                                    </button>
                                </div>
                            </div>
                            <button
                                type="submit"
                                disabled={loading}
                                style={{ ...dynamicStyles.buttonAgregar, width: '100%', marginTop: 10, opacity: loading ? 0.75 : 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}
                                onMouseOver={(e) => { if (!loading) e.currentTarget.style.backgroundColor = dynamicStyles.buttonHoverAgregar.backgroundColor }}
                                onMouseOut={(e) => { if (!loading) e.currentTarget.style.backgroundColor = dynamicStyles.buttonAgregar.backgroundColor }}>
                                {loading ? <><ClipLoader size={16} color="#fff" /> Iniciando sesión...</> : 'Iniciar sesión'}
                            </button>
                        </form>

                        <p style={dynamicStyles.footerText}>
                            ¿Olvidó su clave? <button type="button" onClick={mostrarRecuperarAcceso} style={styles.recoverLinkButton}>Recuperar</button>
                        </p>
                    </div>
                </div>

            </div>
        </div>
    );
}

const styles = {
    imageContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: 25,
    },
    inputGroup: {
        marginBottom: '15px',
        textAlign: 'left'
    },
    passwordWrapper: {
        position: 'relative',
        width: '100%'
    },
    passwordToggleButton: {
        position: 'absolute',
        top: '50%',
        right: 10,
        transform: 'translateY(-50%)',
        border: 'none',
        background: 'transparent',
        cursor: 'pointer',
        padding: 0,
        lineHeight: 1,
        fontSize: 19,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    button: {
        width: '100%',
        backgroundColor: '#972034',
        color: '#fff',
        padding: '10px',
        border: 'none',
        borderRadius: '5px',
        fontSize: '16px',
        fontWeight: 'bold',
        cursor: 'pointer',
        transition: 'background 0.3s',
    },
    buttonHover: {
        backgroundColor: '#A23C41'
    },
    link: {
        color: '#0F6EFD',
        fontWeight: 'bold',
        textDecoration: 'none'
    },
    recoverLinkButton: {
        border: 'none',
        background: 'transparent',
        color: '#0F6EFD',
        fontWeight: 'bold',
        textDecoration: 'none',
        padding: 0,
        cursor: 'pointer'
    }
};
